<template>
  <BLayout :colors="$site.colors" :header-back-route="{ path: '/customer' }">
    <BContainer>
      <div v-if="email" class="flex flex-col items-center">
        <h2 class="text-primary text-center text-2xl font-bold mb-4">
          {{ $t("pages.customer.success.title") }}
        </h2>
        <p class="mb-6">
          {{ $t("pages.customer.success.info", { email }) }}
        </p>
        <UButton
          v-if="$site.settings.allowNewRegistrations"
          variant="soft"
          to="/customer/login"
          class="mx-auto"
        >
          {{ $t("pages.customer.success.button") }}
        </UButton>
      </div>
      <div v-else class="text-center">
        <BSpinner label="Loading" />
      </div>
    </BContainer>
  </BLayout>
</template>

<script setup lang="ts">
const route = useRoute()
const email = ref<string | undefined>(route.query?.email as string | undefined)

onMounted(() => {
  if (!email.value) {
    navigateTo('/')
  }
})
</script>
